import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { EntityType } from '~/enums/EntityType';
import { QueryFiltersFormField } from '~/features/advanced-search/query-filters/QueryFiltersFormField';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { slices } from '~/redux/slices';
import { Nullable } from '~/types/Nullable';

import { INITIAL_FILTERS } from '../../constants';
import { DocumentsInScope } from './DocumentsInScope';

interface Props {
  entityId: Nullable<string>;
  entityType: EntityType.DocumentAttachedData | EntityType.Field;
  readOnly: boolean;
  title?: string;
  info?: string;
}

export const ModelScopeSelect = ({
  entityId,
  entityType,
  readOnly,
  title,
  info,
}: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const query = useSelector(slices.xRay.selectors.selectQuery);
  const enableXrayNewPricingModel = useFlag(
    FlagType.DocumentXrayNewPricingModel,
  );

  return (
    <Layout preset="subsections">
      <QueryFiltersFormField
        info={info}
        defaultFilters={INITIAL_FILTERS}
        description={intl.formatMessage({
          id: 'XRayConfiguration.scope.description',
          defaultMessage:
            'Use filters to choose which documents the model will run on.',
          description: 'Description for setting the scope of the model.',
        })}
        mode="preview"
        optional={false}
        query={query}
        readOnly={readOnly}
        title={
          title ??
          intl.formatMessage({
            id: 'XRayConfiguration.scope.label',
            defaultMessage: 'Scope',
            description:
              'Label of the form field to set the scope of the model.',
          })
        }
        onQueryChange={(updatedQuery) =>
          dispatch(slices.xRay.actions.setQuery(updatedQuery))
        }
      />
      {enableXrayNewPricingModel && (
        <DocumentsInScope
          query={query}
          entityId={entityId}
          entityType={entityType}
        />
      )}
    </Layout>
  );
};
